export default __webpack_public_path__ + "static/media/linkedin.cf407b5c.svg";